import React, { useState } from "react";
import ReactMarkdown from "react-markdown";

const ConversationSummary = ({ conversation, hideTitle = false }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleSummary = () => setIsExpanded(prev => !prev);

  if (!conversation?.summary) return "N/A";

  const [rawSummary] = conversation.summary.split("\n\n");

  if (!rawSummary) return "N/A";

  const summary = rawSummary?.replace("Summary: ", "");
  const shortSummary = summary.substring(0, 100);

  return (
    <div>
      {!hideTitle && (
        <span className="font-semibold max-w-full break-words">Summary:</span>
      )}
      {summary.length <= 30 || isExpanded ? (
        <>
          <ReactMarkdown>{summary}</ReactMarkdown>
          <button className="italic underline" onClick={toggleSummary}>
            (show less)
          </button>
        </>
      ) : (
        <div className="text-sm">
          {shortSummary}...
          <button className="italic underline" onClick={toggleSummary}>
            (show more)
          </button>
        </div>
      )}
    </div>
  );
};

export default ConversationSummary;
